var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPause(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.79522 1.56723e-07H6.87145C8.33192 -8.90318e-06 9.47904 -1.5974e-05 10.3747 0.120396C11.2924 0.243787 12.0206 0.50181 12.5927 1.07394C13.1649 1.64607 13.4229 2.37424 13.5463 3.29202C13.6667 4.18763 13.6667 5.33475 13.6667 6.79522V6.87144C13.6667 8.33192 13.6667 9.47904 13.5463 10.3747C13.4229 11.2924 13.1649 12.0206 12.5927 12.5927C12.0206 13.1649 11.2924 13.4229 10.3747 13.5463C9.47904 13.6667 8.33192 13.6667 6.87144 13.6667H6.79522C5.33475 13.6667 4.18763 13.6667 3.29202 13.5463C2.37424 13.4229 1.64607 13.1649 1.07394 12.5927C0.50181 12.0206 0.243787 11.2924 0.120396 10.3747C-1.5974e-05 9.47904 -8.90318e-06 8.33192 1.56723e-07 6.87145V6.79522C-8.90318e-06 5.33475 -1.5974e-05 4.18763 0.120396 3.29202C0.243787 2.37424 0.50181 1.64607 1.07394 1.07394C1.64607 0.50181 2.37424 0.243787 3.29202 0.120396C4.18763 -1.5974e-05 5.33475 -8.90318e-06 6.79522 1.56723e-07Z",
    fill: "#EE0033"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPause);
export default __webpack_public_path__ + "static/media/icon-pause.733503ad5d517d8959e8219a6613e46b.svg";
export { ForwardRef as ReactComponent };